import React, { useEffect, useState } from 'react';
import { Loader2, ScrollText } from 'lucide-react';
import api from '@/lib/adminApi';

const ACTION_STYLE = (a) => {
  if (a.includes('suspend') || a.includes('reject')) return 'text-destructive';
  if (a.includes('approve') || a.includes('reactivate') || a.includes('grant')) return 'text-success';
  return 'text-brand';
};

export default function AdminAudit() {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get('/admin/audit-logs').then((r) => setLogs(r.data.logs)); }, []);

  if (!logs) return <div className="flex h-64 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-brand" /></div>;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-2xl font-bold text-white sm:text-3xl">Audit Log</h1>
        <p className="mt-1 text-sm text-white/50">Every admin action, who performed it, when and from where.</p>
      </div>

      <div className="rounded-2xl border border-white/10 bg-surface/70">
        {logs.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20 text-center text-white/40">
            <ScrollText className="mb-3 h-8 w-8" />
            <p>No admin actions recorded yet.</p>
            <p className="text-xs">Perform an action on a user or provider to see it here.</p>
          </div>
        ) : (
          <ul className="divide-y divide-white/5">
            {logs.map((log) => (
              <li key={log.id} className="flex items-center justify-between px-5 py-3.5">
                <div className="flex items-center gap-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-white/5 font-display text-sm font-bold text-white/70">{log.admin_email.charAt(0).toUpperCase()}</div>
                  <div>
                    <p className="text-sm text-white">
                      <span className="font-medium">{log.admin_email}</span>{' '}
                      <span className={`font-semibold ${ACTION_STYLE(log.action)}`}>{log.action}</span>
                      {log.meta?.email && <span className="text-white/50"> · {log.meta.email}</span>}
                      {log.meta?.name && <span className="text-white/50"> · {log.meta.name}</span>}
                    </p>
                    <p className="text-xs text-white/40">IP {log.ip}</p>
                  </div>
                </div>
                <span className="text-xs text-white/40">{new Date(log.created_at).toLocaleString()}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
